// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  GetHelpCenterChaptersData,
  GetHelpCenterChaptersResponses,
  GetHelpCenterRubricBySlugData,
  GetHelpCenterRubricBySlugResponses,
  GetHelpCenterTravelersQuestionsData,
  GetHelpCenterTravelersQuestionsResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Получить разделы help center
 */
export const getHelpCenterChapters = <ThrowOnError extends boolean = false>(
  options: Options<GetHelpCenterChaptersData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetHelpCenterChaptersResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/help_center/chapters/',
    ...options,
  });

/**
 * Получить рубрику по slug
 */
export const getHelpCenterRubricBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetHelpCenterRubricBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetHelpCenterRubricBySlugResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/help_center/rubrics/{slug}/',
    ...options,
  });

/**
 * Получить вопросы путешественников
 */
export const getHelpCenterTravelersQuestions = <ThrowOnError extends boolean = false>(
  options?: Options<GetHelpCenterTravelersQuestionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHelpCenterTravelersQuestionsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/help_center/travelers/questions/',
    ...options,
  });
